import React, {useState, useEffect} from 'react'
import {useParams, Route} from 'react-router-dom';
import {getAuthorData} from "../../firebase/getData";

import UserIntro from './UserIntro';
import UserPosts from "./UserPosts";
import UserAwards from "./UserAwards";
import UserActivity from "./UserActivity";
import CircularProgress from '@material-ui/core/CircularProgress';
import UserModalWrapper from "./UserModalWrapper"
import {Row, Col} from 'react-bootstrap';

export default function User() {
  const { authorID } = useParams();
  const [authorData, setAuthorData] = useState({});
  const [loading, setLoading] = useState(true);
  const [lastPost, setLastPost] = useState(null);
  const [noMore, setNoMore] = useState(false);

  useEffect(() => {
    getAuthorData({authorID, setLastPost, setState: setAuthorData, setLoading, setNoMore})
  }, [authorID])

  const handleLoad = () => {
    getAuthorData({authorID, setLastPost, existingUser: authorData, lastPost, setLastPost, setState: setAuthorData, setLoading, setNoMore})
  }
  
  let userComponent
  if (!loading) userComponent = (
    <Row className="pt-2 pb-3">
    <Col lg={8} md={12}>
      <UserIntro authorName={authorData.authorName} bio={authorData.bio} location={authorData.location} contacts={authorData.contacts} authorID={authorID}/>
      <UserPosts posts={authorData.posts} handleLoad={handleLoad} noMore={noMore} authorID={authorID}/>
    </Col>
    <Col lg={4} md={12}>
      <UserAwards numberPoints={authorData.numberPoints} numberPosts={authorData.numberPosts} numberComments={authorData.numberComments} upvotesReceived={authorData.upvotesReceived}/>
      <UserActivity activity={authorData.activity} authorID={authorID}/>
    </Col>
  </Row>)
  else userComponent = <CircularProgress />;

  return (
    <div className="mt-5 pt-5 bg-light pb-5">
      <Route path={`/users/${authorID}/posts/:postID`}>
        <UserModalWrapper authorID={authorID} authorData={authorData} setAuthorData={setAuthorData}/>
      </Route>
      <div className="user-profile-container col-xl-10 col-lg-10 col-md-11">
        {userComponent}
      </div>
    </div>
  )
}
